import React from 'react'
import "../static/Footer.css"

function Footer() {
    return (
                <footer class="footer">
        <div class="footer-container">

            <div class="footer-section brand">
            <h2 class="footer-logo">Qaura <span>Tech</span></h2>
            <p>
                Empowering students with modern tech skills.
                Learn. Build. Grow with industry-ready courses.
            </p>
            </div>

            <div class="footer-section">
            <h3>Quick Links</h3>
            <a href="/">Home</a>
            <a href="/courses">Courses</a>
            <a href="/about">About</a>
            <a href="/contact">Contact</a>
            </div>

            <div class="footer-section">
            <h3>Courses</h3>
            <a href="/fullstack">Full Stack Development</a>
            <a href="/datascience">Data Science</a>
            <a href="/aiml">AI & ML</a>
            <a href="/cybersecurity">Cyber Security</a>
            </div>

            <div class="footer-section">
            <h3>Contact</h3>
            <p>Email: support@qauratech.com</p>
            <p>Phone: +91 98765 43210</p>
            <div class="social-icons">
                <a href="/">🌐</a>
                <a href="/">📘</a>
                <a href="/">📸</a>
                <a href="/">🐦</a>
            </div>
            </div>

        </div>

        <div class="footer-bottom">
            © 2026 Qaura Tech Academy. All rights reserved.
        </div>
        </footer>
    )
}

export default Footer
